import { createFileRoute } from "@tanstack/react-router";
import { z } from "zod";

import { CtaSection } from "@/features/landing/modules/cta/cta-section";
import { DashboardPreview } from "@/features/landing/modules/dashboard-preview/dashboard-preview";
import { FaqSection } from "@/features/landing/modules/faq/faq-section";
import { FeaturesSection } from "@/features/landing/modules/features/features-section";
import { HeroSection } from "@/features/landing/modules/hero/hero-section";
import { HowItWorksSection } from "@/features/landing/modules/how-it-works/how-it-works-section";
import { LandingFooter } from "@/features/landing/modules/landing-footer/landing-footer";
import { LandingNav } from "@/features/landing/modules/landing-nav/landing-nav";
import { LeadershipSection } from "@/features/landing/modules/leadership/leadership-section";
import { StatementSection } from "@/features/landing/modules/statement/statement-section";
import { m } from "@/paraglide/messages.js";

export const Route = createFileRoute("/(public)/")({
  component: LandingPage,
  loader: () => ({ crumb: m.landing_home_crumb() }),
  validateSearch: z.object({ redirect: z.string().optional() }),
});

function LandingPage() {
  return (
    <div className="relative flex min-h-svh max-w-[100vw] flex-col overflow-x-clip bg-page-background text-foreground">
      <div
        aria-hidden
        className="pointer-events-none absolute inset-0 bg-[radial-gradient(ellipse_at_50%_-10%,color-mix(in_oklch,var(--primary)_12%,transparent),transparent_55%)]"
      />
      <div className="relative flex flex-1 flex-col">
        <LandingNav />
        <main className="flex-1">
          <HeroSection />
          <div className="relative z-20 mt-10 md:-mt-36">
            <DashboardPreview />
          </div>
          <FeaturesSection />
          <StatementSection />
          <HowItWorksSection />
          <LeadershipSection />
          <FaqSection />
          <CtaSection />
        </main>
        <LandingFooter />
      </div>
    </div>
  );
}
